import { render, staticRenderFns } from "./SectionRichText.vue?vue&type=template&id=cec7210e&"
import script from "./SectionRichText.vue?vue&type=script&lang=js&"
export * from "./SectionRichText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports